__turbopack_context__.v({
  "actions": "product-purchase-module-scss-module__rgPEVq__actions",
  "brand": "product-purchase-module-scss-module__rgPEVq__brand",
  "buy": "product-purchase-module-scss-module__rgPEVq__buy",
  "catLink": "product-purchase-module-scss-module__rgPEVq__catLink",
  "catSep": "product-purchase-module-scss-module__rgPEVq__catSep",
  "cats": "product-purchase-module-scss-module__rgPEVq__cats",
  "cta": "product-purchase-module-scss-module__rgPEVq__cta",
  "ctaDone": "product-purchase-module-scss-module__rgPEVq__ctaDone",
  "descBlock": "product-purchase-module-scss-module__rgPEVq__descBlock",
  "descBody": "product-purchase-module-scss-module__rgPEVq__descBody",
  "descTitle": "product-purchase-module-scss-module__rgPEVq__descTitle",
  "meta": "product-purchase-module-scss-module__rgPEVq__meta",
  "metaChip": "product-purchase-module-scss-module__rgPEVq__metaChip",
  "name": "product-purchase-module-scss-module__rgPEVq__name",
  "panel": "product-purchase-module-scss-module__rgPEVq__panel",
  "points": "product-purchase-module-scss-module__rgPEVq__points",
  "pointsCoin": "product-purchase-module-scss-module__rgPEVq__pointsCoin",
  "pointsFrom": "product-purchase-module-scss-module__rgPEVq__pointsFrom",
  "pointsValue": "product-purchase-module-scss-module__rgPEVq__pointsValue",
  "qty": "product-purchase-module-scss-module__rgPEVq__qty",
  "qtyBtn": "product-purchase-module-scss-module__rgPEVq__qtyBtn",
  "qtyInput": "product-purchase-module-scss-module__rgPEVq__qtyInput",
  "shortDesc": "product-purchase-module-scss-module__rgPEVq__shortDesc",
});
